import TextButton from 'LuxKit/Button/TextButton'
import React from 'react'
import { useIntl } from 'react-intl'

interface Props {
  kind: 'primary' | 'secondary' | 'tertiary'
}

function SearchTilePrimaryActionButton({ kind }: Props) {
  const intl = useIntl()

  return <TextButton nonInteractable kind={kind}>{intl.formatMessage({
    id: 'XdCO5PSioV',
    defaultMessage: 'View offer',
    description: 'Action button label to view offer details on the search tile',
  })}
  </TextButton>
}

export default SearchTilePrimaryActionButton
